import { formatAmountForDisplay, formatDate, toCents } from 'src/utils'
import * as types from './types'

export default {
  [types.ETPS_TO_SHOW](state) {
    return state.etps.map((etp) => ({
      id: etp.id,
      isin: etp.isin,
      state: etp.state,
      clientName: etp.client_name,
      clientId: etp.client_id,
      clientCountry: etp.client_country,
      clientRegistrationNumber: etp.client_registration_number,
      amount: etp.amount,
      formattedAmount: formatAmountForDisplay(etp.amount, etp.currency),
      currency: etp.currency,
      totalInstallments: etp.total_installments ?? 0,
      totalSettledInstallments: etp.total_settled_installments ?? 0,
      createdAt: etp.created_at,
      formattedCreatedAt: formatDate(etp.created_at, 'DD/MM/YYYY'),
      finalMaturityDate: etp.final_maturity_date,
      formattedFinalMaturityDate: etp.final_maturity_date
        ? formatDate(etp.final_maturity_date, 'DD/MM/YYYY')
        : '-'
    }))
  },
  [types.PARAMS_TO_SEND](state) {
    return {
      // pagination
      limit: state.pagination.itemsPerPage,
      offset: (state.pagination.page - 1) * state.pagination.itemsPerPage,
      descending: state.pagination.sortDesc[0],
      sortBy: state.pagination.sortBy[0],
      // filters
      ...state.filters,
      amountFrom: state.filters.amountFrom
        ? toCents(state.filters.amountFrom)
        : null,
      amountTo: state.filters.amountTo ? toCents(state.filters.amountTo) : null,
      state: state.filters.states
    }
  },
  [types.ETP_ORDERS](state) {
    if (!state.selectedEtp?.orders) {
      return []
    }
    return state.selectedEtp.orders.map((order) => {
      return {
        clientName: order.client_name ?? '-',
        investorName: order.investor_name ?? '-',
        state: order.state,
        interest: order.interest
          ? formatAmountForDisplay(order.interest, state.selectedEtp.currency)
          : '-',
        amount: formatAmountForDisplay(
          order.amount,
          state.selectedEtp.currency
        ),
        fee: order.fee
          ? formatAmountForDisplay(order.fee, state.selectedEtp.currency)
          : '-',
        type: order.type
      }
    })
  },
  [types.PENDING_AMOUNT](state) {
    if (!state.selectedEtp.id) {
      0
    }

    let pendingAmount = state.selectedEtp.amount
    state.selectedEtp.orders.forEach((order) => {
      if (order.type === 'BUY') {
        pendingAmount -= order.size
      }
    })
    return pendingAmount
  }
}
